module.exports = __webpack_public_path__ + "img/logo.372f298e.png";